import { reducerTypes } from './types';
import { IBrand } from '../../interfaces/product';
import { IPageInfo } from '../../interfaces/common';

export const getBrandsAction = (data: IBrand[]) => ({
  type: reducerTypes.GET_ALL_BRANDS,
  payload: data,
});

export const getPublicBrandsAction = (data: IBrand[]) => ({
  type: reducerTypes.GET_ALL_PUBLIC_BRANDS,
  payload: data,
});

export const getMoreBrandsAction = (data: IBrand[]) => ({
  type: reducerTypes.GET_MORE_BRANDS,
  payload: data,
});

export const getBrandAction = (data: IBrand) => ({
  type: reducerTypes.GET_BRAND,
  payload: data,
});

export const setSizePageAction = (page: IPageInfo) => ({
  type: reducerTypes.SET_PAGE_INFO,
  payload: page,
});
